import { MuiAlert, Spin, Typography } from '@fox/atoms';
import { FlexColumn, PaddedLargeSide } from '@fox/layout';
import { useContentContext } from '../../content-context';
import { useRepresentativeData } from '../query-hooks/query-implementations';
import { RepresentativeUnit } from './contracts';
import { RepresentativesContextProvider, useRepresentativesContext } from './representatives-context';
import { SourceOrganisation } from './source-org';
import { TargetOrganisation } from './target-org';

export function Representatives() {
	const { contentId, requestToken } = useContentContext();
	const { data, error, loading } = useRepresentativeData({ contentId, requestToken, skip: !contentId || !requestToken });

	if (error) return <MuiAlert severity="error">{error}</MuiAlert>;

	return (
		<Spin size="large" spinning={loading}>
			{data?.map(u => {
				return (
					<RepresentativesContextProvider key={u.id} unit={u}>
						<RepresentativeUnit />
					</RepresentativesContextProvider>
				);
			})}
		</Spin>
	);
}

function RepresentativeUnit() {
	const { unit } = useRepresentativesContext();
	return (
		<PaddedLargeSide className="custom-padding">
			{/* perhaps some tabs if there are more than one unit? <Typography variant="h2">{unit.displayName}</Typography>
			<Typography>Some text to explain what this page actually does?</Typography> */}
			<FlexColumn style={{ alignItems: 'flex-start' }}>
				<Typography variant="h4">Active Conference Events</Typography>
				{unit.targetEntities?.map(target => {
					return <TargetOrganisation key={target.id} target={target} />;
				})}
				<Typography style={{ marginTop: '1rem' }} variant="h4">
					Your Organisational Units
				</Typography>
				{unit.sourceEntities?.map(source => {
					return <SourceOrganisation key={source.id} source={source} />;
				})}
			</FlexColumn>
		</PaddedLargeSide>
	);
}
